import { useState, useEffect, useContext } from "react";
import axios from "axios";
import Context from "../../storage/context";



export default function ReviewsBanner() {
  const CARD_W = 240;
  const CARD_M = 20;
  const TOTAL_CARD = CARD_W + CARD_M;
  let ctx = useContext(Context);





  const distance = ctx.getBanner.length * TOTAL_CARD;

  const css = `
    .rv-container {
      overflow: hidden;
      background: #080f1e;
      padding: 40px 0;
      white-space: nowrap; /* מונע ירידת שורה */
      position: relative;
      direction: ltr; /* חייב LTR בשביל חישוב ה-X של האנימציה */
    }

    .rv-track {
      display: inline-flex;
      /* האנימציה רצה לאורך הסט המקורי בלבד */
      animation: marquee ${ctx.getBanner.length * 7}s linear infinite;
    }

    @keyframes marquee {
      0% { transform: translateX(0); }
      100% { transform: translateX(-${distance}px); }
    }

    .rv-card {
      width: ${CARD_W}px;
      height: 400px;
      margin-right: ${CARD_M}px;
      flex-shrink: 0;
      border-radius: 12px;
      overflow: hidden;
    }

    .rv-card img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .rv-container:hover .rv-track {
      animation-play-state: paused;
    }
      .rv-hdr { text-align: center; margin-bottom: 32px; direction: rtl; }

.rv-tag {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: 11px; font-weight: 700; color: #c9a84c;
  letter-spacing: 2px; text-transform: uppercase; margin-bottom: 8px;
}
.rv-tag::before, .rv-tag::after { content: ''; width: 24px; height: 1px; background: #c9a84c; opacity: .5; }

.rv-title { font-size: 22px; font-weight: 900; color: #edf0f5; }
  `;

  return (
    <div className="rv-container">
      <style>{css}</style>
      <div className="rv-hdr">
        <div className="rv-tag">לקוחות מרוצים</div>
        <h2 className="rv-title">תמונות מדברות בעד עצמן</h2>
      </div>
      <div className="rv-track">

        {[...ctx.getBanner, ...ctx.getBanner, ...ctx.getBanner].map((rev, i) => (
          <div key={i} className="rv-card">
            <img src={`${ctx.api_url}${rev.src}`} alt="" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
}
